import { render, staticRenderFns } from "./AfricanBankForm.vue?vue&type=template&id=d1ee0a86"
import script from "./AfricanBankForm.vue?vue&type=script&lang=js"
export * from "./AfricanBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports